import type { HeadType } from '@atlaskit/dynamic-table/types';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { FormatMessage } from '@atlassian/jira-shared-types/src/general.tsx';
import {
	TITLE,
	CREATOR,
	STATUS_CHANGED_TIMESTAMP,
	ARCHIVED_STATUS,
	TRASHED_STATUS,
	LEAD,
} from '../../../common/constants';
import type { Status } from '../../../common/types';
import messages from './messages';

export default function getTableHeader(formatMessage: FormatMessage, status: Status): HeadType {
	const archivedHeaders = [
		{
			key: STATUS_CHANGED_TIMESTAMP,
			content: formatMessage(messages.planArchivedOnHeading),
			isSortable: true,
		},
	];
	const deletedHeaders = [
		{
			key: STATUS_CHANGED_TIMESTAMP,
			content: formatMessage(messages.planDeletedOnHeading),
			isSortable: true,
		},
	];
	return {
		cells: [
			{
				key: TITLE,
				content: formatMessage(messages.planTitleHeading),
				isSortable: true,
			},
			fg('allow_users_to_change_plan_lead')
				? {
						key: LEAD,
						content: formatMessage(messages.planLeadHeading),
						isSortable: true,
					}
				: {
						key: CREATOR,
						content: formatMessage(messages.planCreatorHeading),
						isSortable: true,
					},
			...(status === ARCHIVED_STATUS ? archivedHeaders : []),
			...(status === TRASHED_STATUS ? deletedHeaders : []),
			{
				content: '',
				width: gridSize,
				testId: 'jira-inactive-plans-directory-base.projects-table.header.actions',
			},
		],
	};
}
